import React from "react";
import UserContext, { UserData } from ".";
import { getProfile } from "api/UserAPI";

type UserProviderProps = {
  children: React.ReactNode;
};

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = React.useState<UserData>(null);

  const setAuthPersist = (userData: UserData): void => {
    localStorage.setItem("access_token", userData.access_token);
    localStorage.setItem("refresh_token", userData.refresh_token);
    userData.user &&
      localStorage.setItem("user", JSON.stringify(userData.user));
  };

  const authCheck = (): boolean => {
    return !!localStorage.getItem("access_token");
  };

  const getLoggedProfile = (): void => {
    const profile = getProfile();
    profile
      .then((res) => {
        if (res.status === 200) setUser(res.data.data);
      })
      .catch((err) => {
        console.log("Error get profile: ", err);
      });
  };

  React.useEffect(() => {
    if (authCheck()) getLoggedProfile();
  }, []);

  const value = {
    user,
    setUser,
    setAuthPersist,
    authCheck,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
